import { object } from "prop-types"
import { Date } from "source/shared/DatetimeFmt"
import { Heading } from "@planningcenter/doxy-web"

const Header = ({ registration }) => {
  return (
    <header className="mb-3">
      <Heading level={1} text={`Registration #${registration.id}`} />
      <div className="mt-1">
        <a href={registration.event.publicUrl}>{registration.event.name}</a>
      </div>
      <div>
        {registration.event.startsAt && (
          <Date
            start={registration.event.startsAt}
            end={registration.event.endsAt}
            style="standard"
            year
          />
        )}
      </div>
    </header>
  )
}

Header.propTypes = {
  registration: object,
}

export default Header
